import {useEffect} from "react"

export const useHandleScroll = (isMoreShown: boolean, setMoreShown: (boolean) => void) => {
    useEffect(() => {
        const handleScroll = () => {
            document.removeEventListener("scroll", handleScroll)
            setMoreShown(true)
        }
        if (!isMoreShown) {
            setTimeout(() => {
                document.addEventListener("scroll", handleScroll)
            }, 100)
        } else {
            document.removeEventListener("scroll", handleScroll)
        }
        return () => {
            document.removeEventListener("scroll", handleScroll)
        }
    }, [isMoreShown])
}

export default useHandleScroll
